export const customerServiceNumber = "+5492236236647"

export const whatsappPurchaseText = "Hola!%20Estoy%20usando%20la%20receta%20digital%20y%20quiero%20conocer%20las%20condiciones%20y%20valor%20del%20servicio%20de%20envío%20de%20recetas%20por%20whatsapp%20sin%20usar%20mi%20teléfono%20personal."